import { Typography } from '@mui/material'
import { t } from '$i18n'
import { MyAccountMainInfo } from './my-account-main-info'
import { MyAccountProfileInfo } from './my-account-profile-info'
import { MyAccountActions } from './my-account-actions'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { HIDE_SCROLLBAR_CLASS } from '$setup/style/constants'
import { MyAccountAppBar } from './my-account-app-bar'
import { toLocale } from '$helper/functions/text'
import { VERSION } from '$setup/version'

export function MyAccount() {
  return (
    <PageWithAppBar
      bodySx={{
        backgroundColor: 'neutral200',
        padding: '8px',
        gap: '8px',
      }}
      bodyClass={HIDE_SCROLLBAR_CLASS}
      appBar={<MyAccountAppBar />}
      useCustomScroller
    >
      <MyAccountMainInfo />
      <MyAccountProfileInfo />
      <MyAccountActions />

      {/* // TODO: Update version based on ENV */}
      <Typography
        variant="body2"
        py="8px"
        color="neutral700"
        textAlign="center"
        sx={{ marginTop: 'auto' }}
      >
        {t('myAccount.version')(toLocale(VERSION))}-2
      </Typography>
    </PageWithAppBar>
  )
}
